import { render, staticRenderFns } from "./Samples.vue?vue&type=template&id=77085e4e&scoped=true&"
import script from "./Samples.vue?vue&type=script&lang=ts&"
export * from "./Samples.vue?vue&type=script&lang=ts&"
import style0 from "./Samples.vue?vue&type=style&index=0&id=77085e4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77085e4e",
  null
  
)

export default component.exports